/* CheStore x Chesy & Co. — Luxury Minimalist interactions */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ensureBlobField() {
    if (document.querySelector('.lg-blob-field')) return;
    var field = document.createElement('div');
    field.className = 'lg-blob-field';
    field.innerHTML =
      '<div class="lg-blob lg-blob--1"></div>' +
      '<div class="lg-blob lg-blob--2"></div>';
    document.body.appendChild(field);
  }

  function initReveal() {
    var targets = document.querySelectorAll(
      '.card-wrapper, .product-card, section, .banner, .rich-text, .collection-list__item'
    );
    if (!('IntersectionObserver' in window) || reducedMotion) {
      targets.forEach(function (el) { el.classList.add('lg-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lg-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    targets.forEach(function (el) {
      el.classList.add('lg-reveal');
      io.observe(el);
    });
  }

  // A restrained press ripple, gold-tinted — used sparingly, not on every tap
  function initRipple() {
    document.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest && e.target.closest('.button');
      if (!btn || reducedMotion) return;

      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height);
      var ripple = document.createElement('span');
      ripple.className = 'lg-ripple';
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
      ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';

      var prevPosition = btn.style.position;
      if (getComputedStyle(btn).position === 'static') {
        btn.style.position = 'relative';
      }
      btn.appendChild(ripple);
      ripple.addEventListener('animationend', function () {
        ripple.remove();
        if (prevPosition !== undefined) btn.style.position = prevPosition;
      });
    });
  }

  function init() {
    ensureBlobField();
    initReveal();
    initRipple();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', initReveal);
})();
